module.exports = __webpack_public_path__ + "static/media/IMG_7278_DxO.bc921015.jpg";